import styled, { css } from 'styled-components';

export const Back = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  margin: 0 !important;
  background-color: rgba(0, 0, 0, 0.55);
`;

export const Wrapper = styled.div`
  position: fixed;
  z-index: 999;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5);
  color: #333;
  width: ${(props) => props.w}px;
  /* left: 50%; */
  /* margin: 0 0 0 -${(props) => props.w / 2}px; */
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  ${(props) =>
    !!props.top &&
    css`
      top: ${(props) => props.top}%;
      transform: translate(-50%, 0);
    `}

  ${(props) =>
    (props.theme === 'dark' || props.theme.theme === 'dark') &&
    css`
      background-color: #393e44;
      color: #fff;
      padding: 0;
    `}
`;

export const Content = styled.div`
  padding: 20px 35px; // 35px;
  position: relative;
  &.loading {
    position: relative;
    min-height: 38px;
  }
  &.loading:after {
    content: '';
    position: absolute;
    left: -5px;
    top: -5px;
    right: -5px;
    bottom: -5px;
    z-index: 999;
    border-radius: 4px;
    background: rgba(255, 255, 255, 0.75) url(/images/loader.svg) no-repeat 50%;
    ${(props) =>
      props.theme.theme === 'dark' &&
      css`
        background: rgba(0, 0, 0, 0.85) url(/images/loader-white.svg) no-repeat 50%;
      `}
  }
`;

export const Title = styled.div`
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  color: ${(props) => (props.theme.theme === 'dark' ? '#eee' : '#262b31')};
  margin: 0px 0px 15px;
`;
